import { Colors } from "./colors";
import { IconProps } from "~/model/Icon";

export const defaultIconProps: IconProps = {
  size: 18,
  fill: Colors.Black,
};
